import { postAuth, AUTH_ENDPOINTS } from '@/api/auth'
import { markAuthChecked } from '@/router'
import { getTelegramWebApp, initTelegramWebAppChrome, isTelegramWebApp } from '@/telegram/webapp'

let attempted = false

export async function tryTelegramWebAppAuth(): Promise<boolean> {
  if (!isTelegramWebApp() || attempted) {
    return false
  }
  attempted = true
  initTelegramWebAppChrome()

  const initData = getTelegramWebApp()?.initData
  if (!initData) {
    return false
  }

  const { ok } = await postAuth(AUTH_ENDPOINTS.telegramWebapp, { init_data: initData })
  if (ok) {
    markAuthChecked()
    return true
  }
  return false
}

export { isTelegramWebApp }
